// ConfirmEmail.js - Verifica el correo usando el token de la URL y redirige al login
import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import API_CONFIG from '../config/api';

const ConfirmEmail = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('verificando');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setMessage('Token no válido. Por favor, solicita un nuevo enlace de verificación.');
      return;
    }

    const verifyEmail = async () => {
      try {
        const baseUrl = API_CONFIG.BASE_URL;
        const response = await fetch(`${baseUrl}/api/auth/confirm-email?token=${encodeURIComponent(token)}`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' }
        });
        const data = await response.json();

        if (data.success) {
          setStatus('success');
          setMessage(data.message || 'Correo verificado exitosamente.');
          setTimeout(() => {
            navigate('/login?verified=1', { replace: true });
          }, 2000);
        } else {
          setStatus('error');
          setMessage(data.error || 'El enlace ha expirado o no es válido.');
          setTimeout(() => {
            navigate('/login?error=token_invalid', { replace: true });
          }, 3000);
        }
      } catch (err) {
        setStatus('error');
        setMessage('Error al verificar el correo. Intenta nuevamente.');
        setTimeout(() => {
          navigate('/login?error=verification_failed', { replace: true });
        }, 3000);
      }
    };

    verifyEmail();
  }, [searchParams, navigate]);

  return (
    <div className="main-container">
      <Header />
      <div style={{
        minHeight: '70vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 20px',
        background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)'
      }}>
        <div style={{
          background: 'white',
          borderRadius: '12px',
          boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
          padding: '40px',
          maxWidth: '450px',
          width: '100%',
          textAlign: 'center'
        }}>
          {status === 'verificando' && (
            <>
              <div style={{ fontSize: '48px', marginBottom: '20px' }}>⏳</div>
              <h1 style={{ fontSize: '24px', marginBottom: '10px', color: '#1a1a1a' }}>
                Verificando tu correo...
              </h1>
              <p style={{ color: '#6b7280' }}>Espera un momento.</p>
            </>
          )}
          {status === 'success' && (
            <>
              <div style={{ fontSize: '64px', marginBottom: '20px' }}>✅</div>
              <h1 style={{ fontSize: '24px', marginBottom: '10px', color: '#1a1a1a' }}>
                ¡Correo verificado!
              </h1>
              <p style={{ color: '#6b7280', marginBottom: '20px' }}>{message}</p>
              <p style={{ fontSize: '14px', color: '#9ca3af' }}>
                Redirigiendo al inicio de sesión...
              </p>
            </>
          )}
          {status === 'error' && (
            <>
              <div style={{ fontSize: '64px', marginBottom: '20px' }}>❌</div>
              <h1 style={{ fontSize: '24px', marginBottom: '10px', color: '#dc2626' }}>
                Error de verificación
              </h1>
              <p style={{ color: '#6b7280', marginBottom: '20px' }}>{message}</p>
              <p style={{ fontSize: '14px', color: '#9ca3af' }}>
                Redirigiendo al login...
              </p>
            </>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ConfirmEmail;
